import { Model } from "@iventis/domain-model/model/model";
import testIconPng from "../assets/test-icon.png";
import testIcon2Png from "../assets/test-icon-2.png";
import lorryModel from "./assets/lorry.glb";
import busModel from "./assets/school-bus.glb";

export enum TestingAssetId {
    SchoolBus = "school-bus",
    TestIcon = "test-icon",
    TestIcon2 = "test-icon-2",
    Lorry = "lorry",
}

export enum TestingModelId {
    SchoolBus = "school-bus",
    Lorry = "lorry",
}

export const getTestAssetUrl = (id: TestingAssetId): string => {
    switch (id) {
        case TestingAssetId.SchoolBus:
            return busModel;
        case TestingAssetId.Lorry:
            return lorryModel;
        case TestingAssetId.TestIcon:
            return testIconPng;
        case TestingAssetId.TestIcon2:
            return testIcon2Png;
        default:
            throw new Error(`Testing asset with id: ${id} not supported.`);
    }
};

export const getTestModel = (id: TestingModelId): Model => {
    switch (id) {
        case TestingModelId.SchoolBus:
        case TestingModelId.Lorry:
            return {
                id,
                name: id,
                thumbnailAssetId: "",
                lods: [{ id: null, lod: null, modelId: id, files: [{ id: null, lodId: null, type: "gltf", assetId: id }] }],
                categories: [],
            };
        default:
            throw new Error(`Testing model with id: ${id} not supported.`);
    }
};
